<h2 mat-dialog-title>Confirmación</h2>
<div mat-dialog-content>
    <p>{{data.mensaje}}</p>
</div>
<div mat-dialog-actions class="justify-content-center">
    <button mdbBtn type="button" color="deep-purple" (click)="confirmado()" outline="true" mdbWavesEffect>Si</button>
    <button mdbBtn type="button" color="deep-purple" (click)="cerrarDialogo()" outline="true" mdbWavesEffect>No</button>
</div>
